import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export class DialogEffects {
  modalService = inject(NgbModal);
}
